import React from "react";
import { Select } from "antd";

const PastTenYearsSelect = ({ value, onChange, fromTimestamp }) => {
  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  const fallbackStartYear = currentYear - 5;

  const startYear = fromTimestamp
    ? new Date(fromTimestamp).getFullYear()
    : fallbackStartYear;

  for (let year = currentYear; year >= startYear; year--) {
    yearOptions.push({
      label: year.toString(),
      value: new Date(year, 0, 1).getTime(), // Jan 1st timestamp
    });
  }

  return (
    <Select
      placeholder="Select Year"
      options={yearOptions}
      className="statistics-year-select"
      value={value}
      onChange={onChange}
    />
  );
};

export default PastTenYearsSelect;
